import React, { useState } from 'react';

import Autosuggest from 'react-autosuggest';
import createTrie from 'autosuggest-trie';

const gmdv = require(`../../../ghc_config`);

const centersautosuggester = (props) => {
    
    let handleCurrentLocation = () => {
        props.handleCN();
        setValue('') 
    }

    // Check if a Center Name is present more than once
    const countInArray = (array, what) => {
        return array.filter(item => item.node.title == what.node.title).length;
    }

    // list of Centers Names that we'd like to autosuggest.
    let centersnames = [];
    let stateSpa = ``;
    {props.locations.length ? props.locations.map((item) => {
        stateSpa = gmdv.selectState(item.node.field_state).name
        if (countInArray(props.locations, item) > 1 ) {
            centersnames.push({name: `${item.node.title} (in ${stateSpa})`})
        }
        else {
            centersnames.push({name: `${item.node.title}`})
        }
    }): null}  
    const trie = createTrie(centersnames, 'name'); 

    // Teach Autosuggest how to calculate suggestions for any given input value.
    const getSuggestions = (value) => {
        return trie.getMatches(value.trim().toLowerCase());
    };

    // When suggestion is clicked, Autosuggest needs to populate the input
    // based on the clicked suggestion. Teach Autosuggest how to calculate the
    // input value for every given suggestion.
    const getSuggestionValue = (suggestion) => suggestion.name;
    
    // Use your imagination to render suggestions.
    const renderSuggestion = (suggestion) => (
        <div>
            {suggestion.name}
        </div>
    );

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    const [value, setValue] = useState('')
    const [suggestions, setSuggestions] = useState([])

    const onChange = (event, { newValue }) => {
        setValue(newValue)
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value))
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    const onSuggestionsClearRequested = () => {
        setSuggestions([])
    };

    // Autosuggest will pass through all these props to the input.
    let inputProps = {
        placeholder: props.placeholderCName,
        value: value,
        onChange: onChange
    };

    // Functions to validate thename center and return relative lats and lngs
    const handleLatLongValue = (cname) => {
        if(findArrayElementByName(cname)) {
            props.handleCentersNames(findArrayElementByName(cname))
        }
    }

    const findArrayElementByName = (title) => {
        return props.locations.find((element) => {
            stateSpa = gmdv.selectState(element.node.field_state).name
            let titleName = ``
            if (countInArray(props.locations, element) > 1 ) {
                titleName = `${element.node.title} (in ${gmdv.selectState(element.node.field_state).name})`
            }
            else {
                titleName = `${element.node.title}`
            }
            return titleName === title;
        })
    }

    return(
        <>
            <label htmlFor="Autosuggester" className="red-text-Genesis">
            Find a location - <span 
                className="red-text-Genesis currentLocation"
                onClick={() => handleCurrentLocation()}
            >Current Location</span>
            </label>
            <Autosuggest 
                suggestions={suggestions.slice(0, 10)}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
                onSuggestionSelected={handleLatLongValue(value)} />
        </>
    )
}

export default centersautosuggester